export { default } from './TableBody';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableBody/index.js
// module id = 361
// module chunks = 0